// Auto-generated file created by svgr-cli source svg-template.js
// Run pnpm run create to update
// Do not edit
import * as React from 'react';
import type { SVGProps } from 'react';
const SvgTechnologyAnnouncement = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M10 12.534c1.546.478 3.085 1.076 5 1.92V5.513c-1.956.825-3.485 1.423-5 1.907zm-2-4.54c-1.183.304-2.459.57-4 .846v2.32c1.525.27 2.808.527 4 .82zm9 7.228c0 1.102-1.139 1.81-2.121 1.368-1.638-.737-2.977-1.292-4.246-1.74l.989 3.688a1.5 1.5 0 0 1-1.061 1.837l-1.932.518a1.5 1.5 0 0 1-1.837-1.06L5.066 13.39c-.568-.11-1.171-.22-1.82-.333A1.502 1.502 0 0 1 2 11.578V8.422c0-.735.531-1.354 1.244-1.48 4.837-.846 6.906-1.534 11.664-3.562.98-.418 2.092.293 2.092 1.379zm-7.44 3.35-1.187-4.429c-.363-.099-.731-.193-1.11-.284l1.331 4.973zM21.38 4.13a.5.5 0 0 1 .613.354l.259.966a.5.5 0 0 1-.354.612l-2.897.777a.5.5 0 0 1-.613-.354l-.259-.966a.5.5 0 0 1 .354-.612zM19.19 9.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5zm2.708 4.406a.5.5 0 0 1 .354.612l-.259.966a.5.5 0 0 1-.612.354l-2.898-.777a.5.5 0 0 1-.354-.612l.26-.966a.5.5 0 0 1 .611-.354z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgTechnologyAnnouncement;
